import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrls: ['./user-dialog.component.scss'], // Updated to .scss
  standalone : false
})
export class UserDialogComponent {
  editForm: FormGroup;
  viewMode: boolean;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private dialogRef: MatDialogRef<UserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { user: User | null; viewMode: boolean }
  ) {
    this.viewMode = data.viewMode;
    this.editForm = this.fb.group({
      id: [data.user?.id || 0],
      firstName: [data.user?.firstName || ''],
      lastName: [data.user?.lastName || ''],
      email: [data.user?.email || ''],
      nickname: [data.user?.nickname || ''],
      isActive: [data.user?.isActive || false],
      isAdministrator: [data.user?.isAdministrator || false],
      password: [''],
      comments: [data.user?.comments || '']
    });
  }

  saveChanges(): void {
    if (this.editForm.valid) {
      const userData = this.editForm.value;
      if (userData.id === 0) {
        this.userService.createUser(userData).subscribe(() => {
          this.dialogRef.close(true);
        });
      } else {
        this.userService.updateUser(userData.id, userData).subscribe(() => {
          this.dialogRef.close(true);
        });
      }
    }
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }
}
